export enum TipoPedido {
  DELIVERY = 'DELIVERY',
  RETIRADA = 'RETIRADA',
  MESA = 'MESA'
}
